<template>
  <div id="base-upload-container" ref="dropzoneContainer">
    <div id="dropzone" ref="dropzone" @click="openUpload" :class="{over: insideDropZone}">
      <div v-if="!insideDropZone && !showDropZone" class="dropzone-inner">
        <icon-upload class="upload-icon"/>
        <h6>{{$t("upload.drag_and_drop")}}</h6>
        <p class="attensi-body1 upload-text">{{$t("upload.to_upload")}}</p>

        <div class="spacer"></div>

        <p class="attensi-body1 upload-text">{{$t("upload.or_browse_computer_and")}}</p>
        <label for="file-upload">
          <base-button id="select-file-button">{{$t("upload.select_file")}}</base-button>
          <input type="file" id="file-upload" ref="fileUpload" @change="uploadFileEvent($event)">
        </label>
      </div>

      <div v-else class="dropzone-inner">
        <icon-upload class="upload-icon"/>
        <h6>{{$t("upload.drop_here_to_upload")}}</h6>
      </div>

      <base-spinner v-if="isProcessing"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#base-upload-container {
  background-color: $primary-color;
  box-shadow: $primary-box-shadow;
  border-radius: $border-radius-normal;

  display: flex;
}
#dropzone {
  cursor: pointer;

  width: 100%;
  margin: 16px;

  border-radius: $border-radius-normal;
  border-color: $primary-content-color;
  border-style: dashed;
  border-width: 3px;
  &.over {
    border-width: 5px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  color: $primary-content-color;
  fill: $primary-content-color;
}

.dropzone-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.upload-icon {
  margin: 24px;
  max-width: 140px;
  max-height: 140px;
}
.upload-text {
  margin: 6px;
  text-align: center;
}
.spacer {
  height: 60px;
}

#file-upload {
  display: none;
}
#select-file-button {
  margin: 16px;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";

import { ProcessFileHandler } from "./../../service/processFileHandler";
import { ProcessUnZipper } from "./../../service/processUnZipper";

export default {
  props: {
    showDropZone: Boolean,
  },
  data() {
    return {
      insideDropZone: false,
      isProcessing: false
    };
  },
  computed: {
    ...mapGetters("processModule", ["categories", "reviewProcess"])
  },
  watch: {
    reviewProcess: {
      immediate: true,
      handler(newReviewProcess) {
        this.isProcessing = false;
      }
    }
  },
  mounted() {
    const dropzone = this.$refs.dropzone;
    const dropzoneContainer = this.$refs.dropzoneContainer;
    window.addEventListener("drop", function (e) {
      e.preventDefault();
    });
    document.addEventListener("drop", function (e) {
      e.preventDefault();
    });
    dropzone.addEventListener("dragover", function (e) {
      e.preventDefault();
    });
    dropzoneContainer.addEventListener("dragleave", this.dropzoneLeave);
    dropzone.addEventListener("dragenter", this.dropzoneEnter);
    dropzone.addEventListener("drop", this.dropzoneDrop);
  },
  methods: {
    ...mapActions({ setReviewProcess: "processModule/setReviewProcess" }),
    openUpload() {
      this.$refs.fileUpload.click();
    },
    uploadFileEvent(event) {
      const file = event.target.files[0];
      this.handleFile(file);
    },
    dropzoneDrop(ev) {
      ev.preventDefault();
      this.insideDropZone = false;
      const file = ev.dataTransfer.files[0];
      this.handleFile(file);
    },
    async handleFile(file = null) {
      // TODO MAKE IT POSSIBLE TO UPLOAD SEVERAL FILES ?
      if (!file) {
        console.log("No file!");
        return;
      }
      this.isProcessing = true;

      const processUnZipper = new ProcessUnZipper();
      const files = await processUnZipper.unZip(file);

      if (!files) {
        // TODO MAKE THIS MORE APPARENT TO USER
        alert("Only .apr files are allowed");
        this.isProcessing = false;
        return;
      }

      const rawProcess = files.find(file => file.name === "process.json");
 
      const steps = rawProcess.data.Steps.map((rawStep) => {
        return {
          clickBounds: {
            top: rawStep.ClickBounds.Top,
            right: rawStep.ClickBounds.Right,
            bottom: rawStep.ClickBounds.Bottom,
            left: rawStep.ClickBounds.Left,
          },
          hint: rawStep.Hint,
          imagePath: rawStep.ImagePath,
          index: rawStep.Index,
          milestone: rawStep.Milestone,
        }
      });

      const process = {
        category: null,
        steps: steps,
        id: this._getNewId(),
        title: rawProcess.name
      };
      const images = files.filter(file => file.type === "png");

      let i = 0;
      process.steps.forEach(step => {
        step.index = i;
        step.Image = images[i];
        i++;
      });

      this.setReviewProcess(process);
    },
    dropzoneEnter(ev) {
      this.insideDropZone = true;
    },
    dropzoneLeave(ev) {
      if (!this.isInSideDropZone(ev)) {
        this.insideDropZone = false;
      }
    },
    isInSideDropZone(event) {
      if (event.relatedTarget.id === "dropzone") {
        return true;
      }
      if (event.srcElement && event.srcElement.id === "dropzone") {
        return true;
      }
      let current = event.target.parentElement;
      while (current) {
        if (current.id === "dropzone") {
          return true;
        }
        current = current.parentElement;
      }
      return false;
    },
    _getNewId() {
      const date = new Date();
      const day = date.getDate().toString();
      const month = (date.getMonth() + 1).toString();
      const year = date.getFullYear().toString();
      var text = day + month + year;
      var possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 10; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    }
  },
  beforeDestroy() {
    const dropzone = this.$refs.dropzone;
    const dropzoneContainer = this.$refs.dropzoneContainer;
    window.removeEventListener("drop", function (e) {
      e.preventDefault();
    });
    document.removeEventListener("drop", function (e) {
      e.preventDefault();
    });
    dropzone.removeEventListener("dragover", function (e) {
      e.preventDefault();
    });
    dropzoneContainer.removeEventListener("dragleave", this.dropzoneLeave);
    dropzone.removeEventListener("dragenter", this.dropzoneEnter);
    dropzone.removeEventListener("drop", this.dropzoneDrop);
  }
};
</script>

